import { InvokeAction as InvokeActionComponent } from "./InvokeAction";
import { loader } from "./loader";

export const InvokeAction = {
  Component: InvokeActionComponent,
  loader,
};
